import { render, staticRenderFns } from "./FieldType24.vue?vue&type=template&id=470c58f4&scoped=true"
import script from "./FieldType24.vue?vue&type=script&lang=js"
export * from "./FieldType24.vue?vue&type=script&lang=js"
import style0 from "./FieldType24.vue?vue&type=style&index=0&id=470c58f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470c58f4",
  null
  
)

export default component.exports